module.exports = __webpack_public_path__ + "img/inter28.116a7219.jpg";